import axios from 'axios';

export const cx = (...values) => values.map(item => typeof item === 'object'
  ? Object.keys(item).filter(key => !!item[key]).join(' ')
  : item
).filter(item => !!item).join(' ');

export const hexToRGB = hex => {
  const m = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/g.exec(hex);

  return m
    ? `${parseInt(m[1], 16)}, ${parseInt(m[2], 16)}, ${parseInt(m[3], 16)}`
    : hex;
};

export const setCookie = (name, value, timeout) => {
  let expires = '';

  if (timeout) {
    const date = new Date();
    date.setTime(date.getTime() + timeout);
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${name}=${value || ''}${expires}; path=/`;
};

export const removeCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
};

export const rgba = (hex, a) => `rgba(${hexToRGB(hex)}, ${a})`;

/**
 * Returns random value between to numbers
 *
 * @param value - number or Array
 *   number - chooses a number between 0 and value
 *   Array - chooses a number between value[0] and value[1]
 */
export const random = (value) => {
  const min = typeof value === typeof [] ? value[0] : 0;
  const max = typeof value === typeof [] ? value[1] : value;

  return min + Math.floor(Math.random() * (max - min));
};

export const reportError = (error, innerStack) => {
  console.error(error);
  console.error(innerStack);

  const url = window.location.href;
  if (url.indexOf('.local.') > 0) {
    // do not log local development errors
    return;
  }

  if (!error || !error.stack) {
    console.log(`The error has no stacktrace, not reported: ${JSON.stringify(error)}`);
    return;
  }

  const stackTrace = JSON.stringify(`${error.stack}${innerStack ? ` \n\n\n ${innerStack}` : ''}`);

  axios.post('/api/report_error', {
    error: stackTrace,
    url,
  });

  console.log(`The error was reported to backend: ${stackTrace}`);
};
